import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import BookingsService from '../../services/bookings.service';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import ChatRestServices from "../../services/chat-rest.service";
import Toast from "../../services/toast.service";
import ChatService from "../../services/chat.service";
import Config from "../../utils/config.service";
import AngularFilterHelperService from "../../services/angular-filter-helper.service";
import AngularBroadcastHelperService from "../../services/angular-broadcast-helper.service";

@Component({
    standalone: true,
    selector: 'modal-booking-request-response',
    templateUrl: './modal-booking-request-response.component.html',
    imports: [ CommonModule, TranslatePipe, ItemErrorComponent, FormsModule ]
})
export class ModalBookingRequestResponseComponent implements OnInit {
    private config: Config = inject(Config);
    private toast: Toast = inject(Toast);
    private bookingsService: BookingsService = inject(BookingsService);
    private chatRestServices: ChatRestServices = inject(ChatRestServices);
    private chatService: ChatService = inject(ChatService);
    private angularHelperService: AngularHelperService = inject(AngularHelperService);
    private dialogRef = inject(MatDialogRef<ModalBookingRequestResponseComponent>);
    private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
    private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
    private data = inject(MAT_DIALOG_DATA);

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);

        this.vm.request = this.angularHelperService.copy(this.vm.request) || {};
        this.vm.uid = 'mbd-' + Date.now();

        this.vm.handleModalClose = this.handleModalClose;
        this.vm.handleFormSubmit = this.handleFormSubmit;
    }

    handleFormSubmit(mainForm: any) {
        this.vm.submitted = true;
        if (mainForm.invalid) return;

        const messageText = this.vm.request.response?.trim();
        if (!messageText) return;

        const customer: any = this.vm.request.user;

        if (!customer?.id) {
            this.bookingsService.markRequestResponded(this.vm.request.id);
            this.vm.request.status = 'RESPONDED';
            this.dialogRef.close();
        } else {
            this.chatRestServices.getChatByFriendId(
                { friendUserId: customer.id },
                (chat) => {
                    if (chat && chat.id) {
                        this.vm.chat = chat;
                        this.sendBookingResponseMessage(messageText, customer);
                    } else {
                        this.sendBookingResponseMessage(messageText, customer);
                    }

                    this.bookingsService.markRequestResponded(this.vm.request.id);
                    this.vm.request.status = 'RESPONDED';

                    if (chat?.id) {
                        this.chatService.openChatById(customer, chat.id);
                    }

                    this.dialogRef.close();
                });
        }

    }

    handleModalClose() {
        this.dialogRef.close();
    }

    private sendBookingResponseMessage(text: string, customer: any) {
        this.vm.loading = true;

        const message: any = {
            contentType: 'TEXT',
            content: text,
            chat: this.vm.chat?.id ? { id: this.vm.chat.id } : null
        };

        this.chatRestServices.sendTextMessage(
            { forUser: customer.id },
            message,
            (res) => {
                if (!this.vm.chat?.id) {
                    this.initNewChat(customer, res);
                } else {
                    this.angularBroadcastHelperService.rootBroadcast(
                        this.config.getBroadcastConfig().Chat.NEW_MESSAGE,
                        [res],
                        this.vm.chat.id
                    );
                }

                this.vm.loading = false;
            },
            (err) => {
                const errorMessage = err?.error?.[0]?.message;
                if (errorMessage === 'MaxLength') {
                    this.toast.showAsync(
                        this.angularFilterHelperService.translate('Chats.Errors.Too_Long'),
                        null,
                        null,
                        'error'
                    );
                }
                this.vm.loading = false;
            }
        );
    }

    initNewChat(user, message) {
        this.chatRestServices.getChatByFriendId({ friendUserId: user.id },
            (chat) => {
                chat.privateChatFriend = user;
                if (!chat.privateChatFriend.fullName && user.firstname && user.lastname) {
                    chat.privateChatFriend.fullName = user.firstname + ' ' + user.lastname;
                }
                chat.lastPost = message;
                chat.lastSeenPostId = message.id;
                chat.conversation = this.vm.chat.conversation;
                chat.localId = this.vm.chat.localId;
                this.chatService.initNewChat(chat);
                this.vm.chat = chat;
                message.chat = chat;
            }, console.error);
    }


}